module.exports = __webpack_public_path__ + "img/imagen_web-logo.6baddd1f.jpg";